class OpalTooltipJs{
	constructor(){
		this.initTooltip();
	}

	initTooltip(){
		$('[data-toggle="tooltip"]').tooltip()
	}
}